var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('reseller-service-form',{attrs:{"loading":_vm.loading,"resellerServiceData":_vm.resellerService,"formErrors":_vm.formErrors},on:{"resellerServiceSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }